import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AttachProfileResponse extends BackendResponse {}

export interface AttachProfileParameters extends NextApiParams {
  username: string;
  password: string;
  concernId: number;
}

export const attachProfile = withNextApi<
  AttachProfileResponse,
  AttachProfileParameters
>("/auth/AttachProfile");
